import { render, staticRenderFns } from "./LandingPageFooter.vue?vue&type=template&id=6d91fc90&scoped=true"
import script from "./LandingPageFooter.vue?vue&type=script&lang=js"
export * from "./LandingPageFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingPageFooter.vue?vue&type=style&index=0&id=6d91fc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d91fc90",
  null
  
)

export default component.exports